import * as React from 'react';
import styled from 'styled-components';
import techCoachTermsPdfUrl from './pdf/SHS_Tech_Coach_Terms_of_Service.pdf';

const Paragraph = styled.p`
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 16px;
`;

const TermsAndConditions: React.SFC = () => {
  return (
    <>
      <Paragraph>
        THIS PLAN (HEREINAFTER REFERRED TO AS THE “PLAN”) IS A LEGAL CONTRACT BETWEEN YOU, US, AND THE ADMINISTRATOR (AS
        HEREINAFTER DEFINED).&nbsp; IT requires you to resolve any disputes with us through binding and individual
        arbitration OR THROUGH SMALL CLAIMS COURT and LIMITs our liability TO YOU.&nbsp; Please read THIS PLAN CAREFULLY
        AND COMPLETELY.&nbsp; If you do not agree with any of its provisions, DO NOT USE THE SERVICES OFFERED BY THIS
        PLAN.&nbsp;
      </Paragraph>
      <Paragraph>
        Obligor:&nbsp;The company obligated under this Plan in all states except Florida is Asurion Warranty Services,
        Inc., whose address is P.O. Box 061078, Chicago, IL &nbsp;60606-1078, telephone 1-866-856-3882. &nbsp;If
        purchased in Florida, the company obligated under this Plan is: &nbsp;Asurion Florida Warranty Services, Inc.,
        P.O. Box 061078, Chicago, IL&nbsp; 60606-1078, telephone 1-866-856-3882.{' '}
      </Paragraph>
      <Paragraph>
        Definitions: Throughout this Plan, the words (1) “we”, “us”, and “our” refer to the company obligated under this
        Plan, as referenced in the Obligor section of this Plan; (2) “administrator” refers to (a) Asurion Services, LLC
        in all states and the District of Columbia except in Florida; (b) Asurion Florida Warranty Services, Inc. in
        Florida. The administrator can be contacted at: P.O. Box 1340, Sterling, VA, 20167, telephone
        844-409-1998;&nbsp; (3) “Verizon Wireless” One Verizon Way, Basking Ridge, NJ 07920 refers to the seller of this
        Plan; (4) “you”, and “your” refer to the individual that purchased this Plan; (5) “breakdown” refers to the
        mechanical or electrical failure of the products caused by: a) defects in materials and/or workmanship, b)
        normal wear and tear, c) power surges and (d) unintentional and accidental damage from handling for portable
        products (ADH) as a result of normal use of the product only for laptops, tablets, portable DVD/Blu-ray players,
        portable handheld gaming devices, wearables, and printer display screens; (6) “product” refers to the eligible
        qualifying products indicated in Section 7(a) below, which are located at your Verizon service address and
        covered under this Plan; and (7) “replacement product” refers to a NEW, REFURBISHED OR REMANUFACTURED PRODUCT,
        OR A PRODUCT of equal or similar features and functionality that performS to the factory specifications of the
        original product.&nbsp; Technological advances may result in us providing a replacement product with a lower
        selling price than the original product.
      </Paragraph>
      <Paragraph>
        Instructions: Please retain these terms and conditions for your records; they are an integral part of this Plan,
        and you may be required to reference them to obtain service. Your billing statement and this Plan, including the
        terms, conditions, limitations, exceptions and exclusions, constitute the entire agreement between you and us.
      </Paragraph>
      <Paragraph>
        Your Responsibilities: The product must be in good working condition prior to your Plan purchase. You must
        follow the instructions that are in the owner’s manual for proper use, care and maintenance of the product.
        Failure to follow the manufacturer’s maintenance and service guidelines may result in the denial of coverage
        under this Plan. We strongly recommend (but do not require as a condition of this Plan) the regular backup of
        data and software. It is important that you back up all data files on your PC prior to the commencement of
        service; repairs to your PC may result in the deletion of such data files.
      </Paragraph>
      <Paragraph>
        Fee:&nbsp; You will be billed a monthly fee in the amount of $20.00, plus applicable taxes, in advance, to
        receive this Plan. AS FURTHER OUTLINED IN SECTION 20, WE MAY CHANGE THE MONTHLY CHARGE FOR THE PLAN, OR WE MAY
        CHANGE THESE TERMS AND CONDITIONS FROM TIME TO TIME UPON THIRTY (30) DAYS WRITTEN NOTICE TO YOU, OR LONGER, AS
        MAY BE REQUIRED BY LAW. SUCH NOTICE MAY BE PROVIDED AS IN A SEPARATE MAILING OR EMAIL OR BY ANY OTHER REASONABLE
        METHOD.&nbsp;{' '}
      </Paragraph>
      <Paragraph>
        Term and Coverage: The Plan will become effective and billing will commence upon your enrollment in the Plan.
        With the exception of access to technical support which begins on your date of enrollment, ALL OTHER{' '}
        <span style={{ textDecoration: 'underline' }}>
          Coverage under the Plan will commence THIRTY-ONE (31) days after your ENROLLMENT IN the Plan. No service will
          be provided during the initial THIRTY (30) days of the Plan.
        </span>
        &nbsp; There will be no lapse in coverage if you relocate your residence, provided that the Plan is active and
        you notify Verizon Wireless of such relocation.&nbsp; This Plan is inclusive of the manufacturer’s warranty; it
        does not replace the manufacturer’s warranty but provides certain additional benefits during the term of the
        manufacturer’s warranty. After the manufacturer’s warranty expires, the Plan continues to provide some of the
        manufacturer’s benefits as well as certain additional benefits as specified in Section 2. If the Plan is
        cancelled, coverage will continue for thirty (30) days after the cancellation date. In the event your product is
        being serviced by an authorized service center when this Plan terminates, the term of this Plan will be extended
        until the repair has been completed and your product has been delivered to you.
      </Paragraph>
      <Paragraph>
        What is Covered: This Plan covers parts and labor costs for the repair or replacement of your product resulting
        from a breakdown, provided your product is: (i) owned by you or a member of your household, and (ii) located at
        your Verizon Wireless service address. We will, at our discretion, repair or replace the product, or reimburse
        you for authorized repairs to or replacement of the product, when required due to a breakdown. Non-original
        parts may be used for repair of the product. If we determine that we cannot service your product as specified in
        this Plan, we may replace it with a replacement product, or we may at our discretion, issue you a gift card or
        check based on the replacement value, age and condition of the product, as determined by us, immediately prior
        to the breakdown. The replacement product immediately becomes a qualifying product and is covered under this
        Plan. At our sole discretion, we may require that you return the claimed product to us as a condition to
        receiving a replacement product or reimbursement. Coverage also includes access to technical support for your
        products and virtually anything they connect to during the term of the Plan. Terms of service for technical
        support can be accessed here:{' '}
        <a href={techCoachTermsPdfUrl} target="_blank">
          Technical Support Terms of Service
        </a>
        .{' '}
      </Paragraph>
      <Paragraph>
        a. Qualifying Products: The Plan covers an unlimited quantity of the following of products, of any size and any
        brand, as outlined below.
      </Paragraph>
      <Paragraph>Home Entertainment and Office:</Paragraph>
      <Paragraph>
        ·&nbsp;Desktops, Laptops, Tablets (collectively referred to as “PC” or “PCs”).&nbsp; Each PC can include one (1)
        of each of the following: an associated external monitor, keyboard (wired or wireless), mouse (wired or
        wireless), modem and external desktop speaker set (wired).&nbsp; PCs eligible for coverage under this Plan are
        those equipped with [a Windows Operating System version Windows 7 or newer or Android version 1.6 or newer and
        Apple computers which are equipped with an Apple operating system version OS X (10) or newer.&nbsp; &nbsp;
      </Paragraph>
      <Paragraph>·&nbsp;Home Router (wired or wireless) of any brand and any age.</Paragraph>
      <Paragraph>·&nbsp;External Hard Drive of any brand and any age.</Paragraph>
      <Paragraph>
        ·&nbsp;Printers and Multifunction Printers (collectively referred to herein as “printer” or “printers”).{' '}
      </Paragraph>
      <Paragraph>
        ·&nbsp;LCD, Plasma or LED televisions (collectively referred to as “television”). Televisions include coverage
        for the original remote control.
      </Paragraph>
      <Paragraph>Other Home Entertainment:</Paragraph>
      <Paragraph>
        ·&nbsp;Gaming Systems (collectively referred to as “gaming system”).&nbsp; Gaming systems include the original
        remote controls.{' '}
      </Paragraph>
      <Paragraph>
        ·&nbsp;DVD Player, Blu-Ray Player and portable DVD players (collectively referred to as “DVD Players”).&nbsp;{' '}
      </Paragraph>
      <Paragraph>
        ·&nbsp;Home Theater system (collectively referred to as “home theater system in a box”) Home theater system in a
        box includes a receiver, sound bar, speakers, Blu-Ray player, amplifier, subwoofer and tuner.{' '}
      </Paragraph>
      <Paragraph>·&nbsp;Bluetooth and Wifi enabled speakers. </Paragraph>
      <Paragraph>·&nbsp;Audio/Video Streaming Devices.</Paragraph>
      <Paragraph>·&nbsp;Premium Audio Headsets.</Paragraph>
      <Paragraph>Wearables:</Paragraph>
      <Paragraph>·&nbsp;Health and Fitness bands.</Paragraph>
      <Paragraph>·&nbsp;Smart watches.</Paragraph>
      <Paragraph>Smart Home Products:</Paragraph>
      <Paragraph>·&nbsp;Smart Device Hub(s). </Paragraph>
      <Paragraph>·&nbsp;Smart Light Dimmer(s).</Paragraph>
      <Paragraph>·&nbsp;Smart Thermostat(s).</Paragraph>
      <Paragraph>·&nbsp;Smart Smoke Detector(s).</Paragraph>
      <Paragraph>·&nbsp;Smart Carbon Monoxide Detector(s).</Paragraph>
      <Paragraph>·&nbsp;Smart Door Lock(s).</Paragraph>
      <Paragraph>·&nbsp;Smart Home Security Camera(s).</Paragraph>
      <Paragraph>·&nbsp;Smart Video Doorbell(s).</Paragraph>
      <Paragraph>
        The products listed within the Smart Home Products above must utilize one of the following home networking
        solutions enabled Wifi, ZigBee, Z-Wave, Insteon or Thread Group to be eligible for this Plan.
      </Paragraph>
      <Paragraph>
        If Your Product Needs Service: In the event your product experiences a breakdown, thirty-one (31) days after
        enrollment to the Plan, you may file a claim by going online to{' '}
        <a href="https://protection.asurion.com/smarthomesupport/en-us">
          https://protection.asurion.com/smarthomesupport/en-us
        </a>
        , twenty-four (24) hours a day, seven (7) days a week or by calling 844-409-1998, twenty-four (24) hours a day,
        seven (7) days a week . Your product may be subject to a service fee for each claim, as further outlined below.
        &nbsp;On-site or depot service or advance exchange may be available, as further outlined below.&nbsp; The
        administrator will inform you during the filing of the claim what type of service your product qualifies for. We
        may require you to fill out a claim facilitation form prior to receiving service or replacement or reimbursement
        for your product. You may also be required to produce a State or Federal issued photo identification as a
        condition to receiving service or replacement or reimbursement.&nbsp; Any abuse of the Plan by you, including
        but not limited to seeking replacement of a product not belonging to you, may result in termination of the Plan
        upon notice. The cost of the replacement product cannot exceed the available balance of funds under the
        aggregate claim limit.&nbsp; Repaired or replaced products are warranted by us for ninety (90) days from the
        date of product receipt by you. In the event that the product fails to function properly during such ninety (90)
        days, we will repair or replace the product at no cost to you. Such services will not be charged against your
        aggregate claim limit under the Plan. All claims under this Plan must be reported to us within sixty (60) days
        after cancellation or termination of the Plan.
      </Paragraph>
      <Paragraph>
        Service Fee: In the event that one of the following products: PCs, televisions, home routers, gaming systems,
        printers, home theater system in a box, Premium Audio Headsets, Bluetooth and Wifi enabled speakers, Health and
        Fitness bands or Smart watches requires service, you will be required to pay a service fee in the amount
        of$89.00, plus applicable taxes.In the event that one of the following products: Smart Door Lock(s), Smart Home
        Security Camera(s), Smart Thermostat or Smart Video Doorbell requires service, you will be required to pay a
        service fee in the amount of$49.00, plus applicable taxes.The service fee must be paid and received in advance
        of the service being provided and may be paid with a valid credit card. The service fee does not apply to the
        repair or replacement of a remote control, game controller, monitor, keyboard, mouse, modem, external speakers
        (wired), DVD Players, Streaming Media Players, Smart Device Hub(s), Smart Light Dimmer(s), Smart Smoke
        Detector(s), or Smart Carbon Monoxide Detector(s) however, the costs associated with the repair or replacement
        of these products will apply toward the aggregate claim limit under the Plan Limits of Liability.
      </Paragraph>
      <Paragraph>
        On-Site Service: If the product requires on-site service, an adult (18 years or older) must be present during
        the time of service. You must provide a safe, non-threatening environment for our technicians in order to
        receive on-site service.&nbsp; If our technicians determine that certain repairs cannot be completed where the
        product is located and must be repaired at another location, this Plan will cover all shipping and handling
        costs. Covered products installed in cabinetry and other types of built-in applications are eligible for service
        as long as you make the product reasonably accessible to the service provider.&nbsp; We are not responsible for
        dismantling or reinstallation of furniture or fixed infrastructures when removing or reinstalling repaired or
        replaced products into furniture or cabinetry.
      </Paragraph>
      <Paragraph>
        Repair Depot Service: If the product is not serviced on-site, it will be shipped to a designated repair depot
        location for service. We will send you a prepaid shipping label and instructions for shipping your product to
        our authorized service center.&nbsp; Standard shipping costs are covered by the Plan.
      </Paragraph>
      <Paragraph>
        Advance Exchange:&nbsp; If the product qualifies for advanced exchange, we will ship you a replacement product
        after the claim has been filed.&nbsp; Upon receipt of the replacement product, the product which was approved
        for replacement must be returned to us at our expense in the return mailer that was shipped to you. You must
        return the product as directed by us per the shipping instructions included in the return mailer, or you may be
        charged a non-returned equipment charge up to the retail price of the failed product. YOU CAN AVOID THIS CHARGE
        BY SIMPLY RETURNING THE PRODUCT AS DIRECTED.
      </Paragraph>
      <Paragraph>
        Registration: Registration of this Plan is not required. At your option, you may register the products to be
        covered by the Plan at any time during the coverage period.
      </Paragraph>
      <Paragraph>Plan Limits of Liability: </Paragraph>
      <Paragraph>
        a.&nbsp;Per Claim Limit: The maximum amount we will pay for the repair or replacement of the product for any
        single claim is $2,000.00 or the aggregate claim limit of this Plan of $5,000.00, whichever is less.{' '}
      </Paragraph>
      <Paragraph>
        b.&nbsp;Aggregate Claim Limit: The maximum amount we will pay for all claims [made in any twelve (12) month
        rolling period] is $5,000.00.&nbsp; The twelve (12) month rolling period begins on the date of your first claim.
      </Paragraph>
      <Paragraph>
        If You Meet or Exceed the Aggregate Limit: We will be responsible for informing you, at the time of the claim,
        if you have reached the $5,000.00 aggregate claim limit. In the event you reach the aggregate claim limit and
        the product requires additional repairs, we will provide you with information on how to get the product
        repaired, however, we will not be responsible for any costs related to these repairs. A covered claim will apply
        to your aggregate claim limit for twelve (12) months after the claim is completed, at which point that claim
        will roll off your account and that claim or the associated costs will be added back to your available aggregate
        claim limit balance. You will continue to have access to technical assistance and support for the duration of
        your enrollment in this Plan, regardless of your aggregate claim limit balance.
      </Paragraph>
      <Paragraph>
        Payment: You agree to pay monthly charges for this Plan as such charges will appear on your Verizon Wireless
        monthly bill or the monthly bill for the credit or debit card which was supplied by you. The monthly rate for
        the Plan was provided to you at the time you subscribed to the Plan and is listed above on this Plan.
        Non-payment by you will result in cancellation of the Plan. All charges, plus all applicable taxes, shall be
        billed on a monthly basis on your Verizon Wireless monthly bill or the credit card or debit card which you
        provided during enrollment into the Plan.&nbsp;It is your responsibility to maintain a valid credit or debit
        card with us to process payments, and failure to do so may cause your Plan to be cancelled.
      </Paragraph>
      <Paragraph>
        Insurance Securing this Plan:&nbsp;This Plan is not a contract of insurance. The obligations of Asurion Warranty
        Services, Inc. under this Plan are secured by an insurance policy provided by Liberty Insurance Underwriters
        Inc. in the following states: AL, AR, CA, CO, CT, GA, HI, IL, IN, KY, MA, ME, MN, MO, MT, NC, NH, NJ, NV, NY,
        OK, OR, SC, TX, UT, VT, VA, WA, WI, WY and all other states required by law.&nbsp;The obligations of Asurion
        Florida Warranty Services, Inc. under this Plan are secured by an insurance policy provided by Liberty Mutual
        Insurance Company.&nbsp; If within sixty (60) days we have not paid you for your covered claim, provided you
        with a refund owed, you are otherwise dissatisfied, or if we become insolvent or otherwise financially impaired,
        you may report a claim directly to the applicable insurance company at 55 Water St., 18th Floor, New York, NY
        10041 for Liberty Insurance Underwriters, Inc. and at 175 Berkeley Street, Boston, Massachusetts, 02116, for
        Liberty Mutual Insurance Company, or by calling toll free 1-800-677-9163.
      </Paragraph>
      <Paragraph>Exclusions – What Is Not Covered: This Plan does not cover the following:</Paragraph>
      <Paragraph>a. Pre-existing conditions at the time of your enrollment in the Plan; </Paragraph>
      <Paragraph>
        b. Cosmetic defects, damage to or failures of non-operational components that do not inhibit the proper
        operation and performance of a covered item, such as but not limited to: appearance parts; broken hinges;
        cracked cases; decorative finishing; finish defects; handles; nonfunctional plastic; trim; accessories;
        attachments;
      </Paragraph>
      <Paragraph>
        c. Breakdown or costs resulting from: improper installation or setup; use in any combinations not approved in
        the manufacturer’s specifications; unauthorized modifications, alterations, repairs or repair personnel;{' '}
      </Paragraph>
      <Paragraph>
        d. Consequential, incidental, special or indirect damages or losses, including but not limited to, loss of use,
        loss of business, loss of profits, loss of data, down-time and charges for time and effort;
      </Paragraph>
      <Paragraph>
        e. Failure, inoperability, or disruption of any product or product functions due to any design flaw or systemic
        manufacturing defect;
      </Paragraph>
      <Paragraph>
        f.&nbsp;Breakdown or loss caused by any physical force external to the product, whether accidental (excluding
        those products as outlined in the Definitions section) or intentional, including but not limited to: any
        disaster, whether natural (acts of God) or man-made, whether local or catastrophic; abuse; acts of war; civil
        disorders; corrosion; dirt; mold; dust; earthquake; fire; hail; insects or other animals; liquid immersion;
        malicious mischief; misuse; negligence; nuclear accident; riot; rust; sand; smoke; storm; terrorist attack;
        vandalism; wind;
      </Paragraph>
      <Paragraph>g.&nbsp;Costs associated with installation or uninstallation of any product; </Paragraph>
      <Paragraph>
        h.&nbsp;Burned-in images and pixel failure within designed specifications or that do not materially alter the
        product’s functionality;
      </Paragraph>
      <Paragraph>
        i.&nbsp;Products that are not owned by you, leased and rented products, or products that are not customarily
        located in your specified residence;
      </Paragraph>
      <Paragraph>
        j.&nbsp;Breakdown of the product either while in storage or in the course of transit, delivery, or redelivery,
        except where the loss or damage occurs while your product is located at our designated repair depot;{' '}
      </Paragraph>
      <Paragraph>
        k.&nbsp;Normal periodic or preventative maintenance, inspections, cleaning, or tune-ups; minor adjustments and
        settings outlined in the product owner&rsquos manual that the user can perform; costs related to any service
        request which results in customer education or no problem found;{' '}
      </Paragraph>
      <Paragraph>l.&nbsp;Products whose serial number has been altered or removed;</Paragraph>
      <Paragraph>m.&nbsp;Products located outside the United States;</Paragraph>
      <Paragraph>
        n.&nbsp;Repair or replacement covered by a manufacturer recall in effect at the time of the breakdown;{' '}
      </Paragraph>
      <Paragraph>
        o.&nbsp;Support or repairs to software; loss or damage to software due to any cause; including but not limited
        to, computer virus; worm; Trojan programs; adware, spyware, firmware or any other software program;{' '}
      </Paragraph>
      <Paragraph>
        p.&nbsp;Data or software of any kind that is deleted or damaged during a repair or replacement under this Plan;
      </Paragraph>
      <Paragraph>q.&nbsp;Theft or loss of the product;</Paragraph>
      <Paragraph>
        r.&nbsp;Special needs accessories including, but not limited to, handset boosters, visual ring indicators, and
        the like;
      </Paragraph>
      <Paragraph>
        s.&nbsp;Parts intended for periodic replacement including but not limited to batteries (excluding one annual
        laptop battery), lamps, bulbs, external power supplies, styluses, antennas, cartridges;&nbsp; &nbsp;&nbsp;
      </Paragraph>
      <Paragraph>
        t.&nbsp;PCs that do not have administrator’s permissions. Covered PCs must be able to upload and download
        software;
      </Paragraph>
      <Paragraph>
        u.&nbsp;Liability or damage to property, or injury or death to any person arising out of the operation,
        maintenance or use of the product; and
      </Paragraph>
      <Paragraph>v. Products connected to Verizon Wireless and covered by one of their insurance products.</Paragraph>
      <Paragraph>Renewal: This Plan automatically renews from month to month until cancelled.</Paragraph>
      <Paragraph>Transfer: This Plan is not assignable or otherwise transferable to another party.</Paragraph>
      <Paragraph>
        Cancellation: This Plan is provided on a month-to-month basis and can be cancelled by you at any time for any
        reason by notifying Verizon Wireless or by contacting the administrator at P.O. Box 1818, Sterling, VA 20167 or
        by calling 844-409-1998. This Plan may be cancelled by us or the administrator for any reason by notifying you
        in writing at least thirty (30) days prior to the effective date of cancellation, which notice shall state the
        effective date and reason for cancellation. If you fail to make any monthly payment or charge due under this
        Plan, your coverage will be cancelled immediately upon our written notice. If the Plan is cancelled: (a) by you
        within thirty (30) days of the receipt of this Plan, you shall receive a full refund of the price paid for the
        Plan, less the cost of any claims which have been paid or repairs that have been made; or (b) by you after
        thirty (30) days of the receipt of this Plan, or cancelled by us or the administrator at any time, you will
        receive a refund equal to 100% of the pro-rata amount of the unearned portion of the price paid for the Plan,
        less the cost of any claims which have been paid or repairs that have been made. &nbsp;For residents of AL, AR,
        CA, CO, HI, MA, MD, ME, MN, MO, NJ, NM, NV, NY, SC, TX, WA, WI and WY any refund owed and not paid or credited
        within thirty (30) days of cancellation shall include a 10% penalty per month.&nbsp; Upon any termination or
        cancellation by you, us or the administrator, after the coverage effective date, you will have coverage provided
        at no cost for an additional thirty (30) days after the date of termination or cancellation of this Plan. All
        claims under this Plan must be reported to us within sixty (60) days after cancellation or termination of the
        Plan.
      </Paragraph>
      <Paragraph>
        Changes to the Plan: WE MAY CHANGE THE MONTHLY CHARGE FOR THE PLAN, OR WE MAY CHANGE THESE TERMS AND CONDITIONS
        FROM TIME TO TIME UPON THIRTY (30) DAYS WRITTEN NOTICE TO YOU OR LONGER AS MAY BE REQUIRED BY LAW. SUCH NOTICE
        MAY BE PROVIDED AS IN A SEPARATE MAILING OR EMAIL OR BY ANY OTHER REASONABLE METHOD. IF YOU DO NOT AGREE TO THE
        MODIFIED CHARGES OR TERMS OF THE AGREEMENT, YOU MAY CANCEL THE PLAN BY NOTICE TO US OR THE ADMINISTRATOR AT ANY
        TIME IN ACCORDANCE WITH THESE TERMS AND CONDITIONS. THE PAYMENT OF APPLICABLE CHARGES BY YOU, OR A REQUEST FOR
        SERVICE UNDER THE PLANS, AFTER RECEIVING SUCH NOTICE OF A CHANGE IN THE CHARGES OR OTHER TERMS AND CONDITIONS
        WILL BE DEEMED TO BE ASSENT BY YOU TO THE CHANGE(S) IN THE CHARGES, TERMS OR CONDITIONS.
      </Paragraph>
      <Paragraph>
        Limitation of Liability: &nbsp;IN NO EVENT WILL THE PLAN OBLIGOR, ADMINISTRATOR OR VERIZON WIRELESS BE LIABLE
        FOR INDIRECT, INCIDENTAL OR CONSEQUENTIAL DAMAGES INCLUDING BUT NOT LIMITED TO PERSONAL INJURIES OR LOSS OF
        INCOME ARISING OUT OF OR CONNECTED TO THE PROVISION OF THE PLAN, REPAIR OR REPLACEMENT OF PRODUCTS UNDER THE
        PLAN AND CAUSED BY NEGLIGENCE, ERROR, MISTAKE OR OMISSION ON THE PART OF THE PLAN OBLIGOR OR ADMINISTRATOR OR
        THEIR RESPECTIVE EMPLOYEES, AGENTS OR SUBCONTRACTORS.
      </Paragraph>
      <Paragraph>
        Force Majeure:&nbsp; We shall not be held responsible for any delay or failure in performance of any part of
        this Plan to the extent that such delay or failure is caused by fire, flood, explosion, war, strike, embargo,
        government requirement, regulatory agency requirement, civil or military authority, acts of God, or other
        similar causes beyond our control.
      </Paragraph>
      <Paragraph>
        Non-waiver: Our failure in any circumstance to require strict adherence to any term or condition set forth
        herein shall not be deemed a waiver by us of any such term or condition under any other circumstance or of any
        other term or condition set forth herein.
      </Paragraph>
      <Paragraph>
        Arbitration Agreement: For the purpose of this arbitration agreement (referred to hereinafter as the “A.A.”)
        only, references to “we” and “us” also include (1) the respective parents, subsidiaries, affiliates, service
        contract insurers, agents, employees, successors and assigns of the Plan obligor and administrator, as defined
        above; and (2) Verizon Wireless and its wholly owned subsidiaries, affiliates, agents, employees, successors and
        assigns.
      </Paragraph>
      <Paragraph>&nbsp;</Paragraph>
      <Paragraph>
        Most of your concerns about the Plan can be addressed simply by contacting us at 1-866-856-3882. In the event we
        cannot resolve any dispute with you, YOU AND We agree to resolve those disputes through binding and individual
        arbitration or through small claims court instead of through courts of general jurisdiction. YOU AND We agree to
        waive THE right to a trial by jury and waive THE RIGHT to participate in class actionS, class arbitrations OR
        OTHER REPRESENTATIVE PROCEEDINGS.&nbsp;{' '}
      </Paragraph>
      <Paragraph>&nbsp;</Paragraph>
      <Paragraph>
        (a) This A.A. shall survive termination of the Plan and is governed by the Federal Arbitration Act. This A.A.
        shall be interpreted broadly, and it includes any dispute you have with us that arises out of or relates in any
        way to the Plan or the relationship between you and us, whether based in contract, tort, statute, fraud,
        misrepresentation or otherwise. However, this A.A. does not preclude you from bringing an individual action
        against us in small claims court or from informing any federal, state or local agencies or entities of your
        dispute. They may be able to seek relief on your behalf.&nbsp;{' '}
      </Paragraph>
      <Paragraph>&nbsp;</Paragraph>
      <Paragraph>
        (b) To initiate arbitration, send a written Notice of Claim by certified mail to: Legal Department, P.O. Box
        110656, Nashville, TN 37122-0656. The Notice must describe the dispute and relief sought. If we do not resolve
        the dispute within (thirty) 30 days of receipt of the Notice, you may start an arbitration with the American
        Arbitration Association (“AAA”). You can contact the AAA and obtain a free copy of their rules and forms at{' '}
        <a href="http://www.adr.org">www.adr.org</a> or 1-800-778-7879. We will reimburse you for a filing fee paid to
        the AAA, and if you are unable to pay a filing fee, we will pay it if you send us a written request.&nbsp;{' '}
      </Paragraph>
      <Paragraph>&nbsp;</Paragraph>
      <Paragraph>
        (c) The arbitration shall be administered by the AAA in accordance with the Consumer Arbitration Rules
        (“Rules”). The arbitrator is bound by the terms of this A.A. and shall decide all issues, with the exception
        that issues relating to the enforceability of this A.A. may be decided by a court. If your dispute is for
        $25,000 or less, the arbitration will be conducted by submitting documents to the arbitrator, unless you request
        an in-person or telephonic hearing or the arbitrator decides that a hearing is necessary. If your dispute is for
        more than $25,000, the right to a hearing will be determined by the Rules. Unless otherwise agreed, any hearing
        will take place in the county or parish of your mailing address. We will pay all filing, administration and
        arbitrator fees for any arbitration, unless your dispute is found by the arbitrator to have been filed for the
        purpose of harassment or is patently frivolous. In that case, the Rules govern payment of such fees.&nbsp;{' '}
      </Paragraph>
      <Paragraph>&nbsp;</Paragraph>
      <Paragraph>
        (d) The arbitrator shall issue a decision including the facts and law supporting it. If the arbitrator finds in
        your favor and issues a damages award that is greater than the value of the last settlement we offered or if we
        made no settlement offer and the arbitrator awards you any damages, we will: (1) pay you the amount of the
        damages award or $7,500, whichever is greater; and (2) pay the attorney’s fees and expenses, if any, you
        reasonably incurred in the arbitration. While that right to fees and expenses is in addition to any right you
        may have under applicable law, you may not recover duplicate awards of fees and expenses. We waive any right we
        may have under applicable law to recover attorney’s fees and expenses from you if we prevail in the arbitration.
      </Paragraph>
      <Paragraph>&nbsp;</Paragraph>
      <Paragraph>
        (e) If you seek declaratory or injunctive relief, that relief can be awarded only to the extent necessary to
        provide you relief. YOU AND WE AGREE THAT EACH PARTY MAY BRING CLAIMS AGAINST THE OTHER ONLY IN AN INDIVIDUAL
        CAPACITY AND NOT IN A PURPORTED CLASS ACTION, CLASS ARBITRATION OR OTHER REPRESENTATIVE PROCEEDING. Unless you
        and we agree otherwise, the arbitrator may not consolidate your dispute with any other person’s dispute and may
        not preside over any form of representative proceeding. If this specific provision is found to be unenforceable,
        then the entirety of this A.A. shall be null and void.
      </Paragraph>
      <Paragraph />
      <Paragraph>If You Reside In One Of The Following States, These Provisions Apply To You:&nbsp; </Paragraph>
      <Paragraph />
      <Paragraph>
        Arizona Residents: If your written notice of cancellation is received prior to the expiration of the term, we
        will not deduct the cost of any claims that have been paid or repairs that have been made from your
        refund.&nbsp; The pre-existing condition exclusion does not apply to conditions occurring prior to the sale of
        the consumer product by the retailer, its assignees, subcontractors and/or representatives. The Arbitration
        Agreement of this Plan does not preclude you from contacting the Consumer Protection Division of the Arizona
        Department of Insurance.
      </Paragraph>
      <Paragraph>&nbsp;</Paragraph>
      <Paragraph>
        California Residents:&nbsp; For all products other than home appliances and home electronic products, the
        Cancellation provision is amended as follows:&nbsp; If the Plan is cancelled: (a) within sixty (60) days of the
        receipt of this Plan, you shall receive a full refund of the price paid for the Plan less the cost of any claims
        that have been paid or repairs that have been made, or (b) after sixty (60) days, you will receive a pro rata
        refund, less the cost of any claims that have been paid or repairs that have been made.
      </Paragraph>
      <Paragraph>&nbsp;</Paragraph>
      <Paragraph>
        Connecticut Residents: The first sentence of the Cancellation provision is deleted and replaced with the
        following: “This Plan is provided on a month-to-month basis and can be cancelled by you at any time for any
        reason, including if the product is returned, sold, lost, stolen or destroyed, by notifying Verizon Wireless, or
        by contacting the administrator at P.O. Box 1818, Sterling, VA 20167 or by calling 844-409-1998.” In the event
        of a dispute with us or the administrator that cannot be resolved, you may contact the State of Connecticut,
        Insurance Department, P.O. Box 816, Hartford, CT 06142-0816, Attn: Consumer Affairs. The complaint must contain
        a description of the dispute, the purchase price of the product, the cost of repair of the product and a copy of
        the Plan. In the event your product is being serviced by an authorized service center when the Plan expires, the
        term of the Plan will be extended until the covered repair has been completed.
      </Paragraph>
      <Paragraph>&nbsp;</Paragraph>
      <Paragraph>
        Florida Residents:&nbsp; The rate charged for this Plan is not subject to regulation by the Florida Office of
        Insurance Regulation. &nbsp;
      </Paragraph>
      <Paragraph>&nbsp;</Paragraph>
      <Paragraph>
        Georgia Residents: We may only cancel this Plan before the expiration of the term on the grounds of fraud,
        material misrepresentation, or failure to pay consideration due therefore. The cancellation shall be in writing
        and shall conform to the requirements of Official Code of Georgia Annotated (O.C.G.A.) 33-24-44.&nbsp; If this
        Plan is cancelled prior to the expiration of the term, we will not deduct the cost of any claims that have been
        paid or repairs that have been made from your refund. This Plan excludes coverage for incidental and
        consequential damages and pre-existing conditions only to the extent such damages or conditions are known to you
        or reasonably should have been known to you.&nbsp; As stated in the Arbitration Agreement of this Plan, either
        party may bring an individual action in small claims court. The Arbitration Agreement provision does not
        preclude you from bringing issues to the attention of federal, state, or local agencies or entities of your
        dispute.&nbsp; Such agencies or entities may be able to seek relief on your behalf. You and we agree to waive
        the right to a trial by jury and waive the right to participate in class actions and class arbitrations or other
        similar proceedings.&nbsp; Nothing contained in the Arbitration Agreement provision of this Plan shall affect
        your right to file a direct claim under the terms of this Plan against Liberty Insurance Underwriters, Inc.
        pursuant to O.C.G.A. 33-7-6.
      </Paragraph>
      <Paragraph>&nbsp;</Paragraph>
      <Paragraph>
        Nevada Residents: If the Plan is cancelled, no deduction shall be made from the refund for the cost of any
        claims that have been paid or repairs that have been made.&nbsp; If this Plan has been in force for a period of
        seventy (70) days, we may only cancel before the expiration of the Plan term due to the following reasons: 1)
        You engage in fraud or material misrepresentation in obtaining this Plan or in filing a claim for service under
        this Plan; 2) You commit any act, omission, or violation of any terms of this Plan after the effective date of
        this Plan which substantially and materially increases the service required under this Plan; or 3) Any material
        change in the nature or extent of the required service or repair, including unauthorized service or repair,
        which occurs after the effective date of this Plan and causes the required service or repair to be substantially
        and materially increased beyond that contemplated at the time this Plan was purchased. If we fail to pay the
        cancellation refund as stated in the Cancellation provision the penalty will be 10% of the purchase price for
        each thirty (30) day period or portion thereof that the refund and any accrued penalties remain unpaid. The
        following language is added to item (c) of the WHAT IS NOT COVERED SECTION: “If a product is modified or altered
        without our authorization, we will only provide applicable coverage that is not related to the unauthorized
        modification or alteration or any breakdowns arising therefrom, unless such coverage is otherwise excluded by
        this Plan.” Contact us at 844-409-1998 with questions, concerns or complaints about this Plan. In the event you
        do not receive satisfaction under this Plan, complaints or questions about this Plan may be directed to the
        Nevada Department of Insurance, telephone (888) 872-3234.&nbsp;&nbsp; &nbsp;
      </Paragraph>
      <Paragraph>&nbsp;</Paragraph>
      <Paragraph>&nbsp;</Paragraph>
      <Paragraph>
        New Hampshire Residents: Contact us at 844-409-1998 with, questions, concerns, or complaints about the
        program.&nbsp; In the event you do not receive satisfaction under this Plan, you may contact the State of New
        Hampshire Insurance Department, 21 South Fruit Street, Suite 14, Concord, NH 03301, telephone number:
        1-603-271-2261. The Arbitration Agreement provision of this Plan is subject to Revised Statues Annotated 542.
      </Paragraph>
      <Paragraph>&nbsp;</Paragraph>
      <Paragraph>
        New Mexico Residents: If this Plan has been in force for a period of seventy (70) days, we may not cancel before
        the expiration of the Plan term or one (1) year, whichever occurs first, unless: (1) you fail to pay any amount
        due; (2) you are convicted of a crime which results in an increase in the service required under the Plan; (3)
        you engage in fraud or material misrepresentation in obtaining this Plan; (4) you commit any act, omission, or
        violation of any terms of this Plan after the effective date of this Plan which substantially and materially
        increase the service required under this Plan; or (5) any material change in the nature or extent of the
        required service or repair occurs after the effective date of this Plan and causes the required service or
        repair to be substantially and materially increased beyond that contemplated at the time you purchased this
        Plan.&nbsp;{' '}
      </Paragraph>
      <Paragraph>&nbsp;</Paragraph>
      <Paragraph>
        North Carolina Residents: The purchase of this Plan is not required either to purchase or to obtain financing
        for the product. We may non-renew, but may only cancel this Plan prior to the expiration of the monthly term for
        nonpayment by you or for violation of any of the terms and conditions of this Plan.
      </Paragraph>
      <Paragraph>&nbsp;</Paragraph>
      <Paragraph>
        Oklahoma Residents: Coverage afforded under this Plan is not guaranteed by the Oklahoma Insurance Guaranty
        Association. Oklahoma service warranty statutes do not apply to commercial use references in this Plan. Oklahoma
        license number:&nbsp; 44197917.&nbsp;&nbsp;&nbsp;&nbsp;{' '}
      </Paragraph>
      <Paragraph>&nbsp;</Paragraph>
      <Paragraph>
        Oregon Residents: &nbsp;The Arbitration Agreement provision of this Plan is replaced with the following: “For
        the purpose of this arbitration agreement, references to “we” and “us” also include the respective parents,
        subsidiaries, affiliates, service contract insurers, agents, employees, successors and assigns of the Plan
        Obligor and administrator, as defined above; and Verizon Wireless and its wholly owned subsidiaries, affiliates,
        agents, employees, successors and assigns. Most of your concerns about the Plan can be addressed simply by
        contacting us at 844-409-1998. In the event we cannot resolve any dispute, you and we may, in a separate
        agreement, consent to arbitration. YOU AND WE AGREE THAT EACH PARTY MAY BRING CLAIMS AGAINST THE OTHER ONLY IN
        AN INDIVIDUAL CAPACITY AND NOT AS A CLASS REPRESENTATIVE OR CLASS MEMBER IN ANY PURPORTED CLASS ACTION, CLASS
        ARBITRATION OR OTHER SIMILAR PROCEEDING. Any arbitration proceedings shall be conducted within the state of
        Oregon.”{' '}
      </Paragraph>
      <Paragraph>&nbsp;</Paragraph>
      <Paragraph>
        South Carolina Residents: Contact us at 844-409-1998 with questions, concerns or complaints about this Plan. In
        the event you do not receive satisfaction under this Plan, complaints or questions about this Plan may be
        directed to the South Carolina Department of Insurance, Capitol Center, 1201 Main Street, Ste. 1000, Columbia,
        SC 29201 or 1-800-768-3467.
      </Paragraph>
      <Paragraph>&nbsp;</Paragraph>
      <Paragraph>
        Texas Residents: If you purchased this Plan in Texas, unresolved complaints concerning us or questions
        concerning our registration may be addressed to the Texas Department of Licensing and Regulation, P.O. Box
        12157, Austin, TX 78711, telephone number (512) 463-6599 or (800) 803-9202.&nbsp; You may apply for
        reimbursement directly to the insurer if a refund or credit is not paid before the forty-sixth (46th) day after
        the date on which the Plan is returned to us. Texas license number: 116.
      </Paragraph>
      <Paragraph>&nbsp;</Paragraph>
      <Paragraph>
        Utah Residents: NOTICE: This Plan is subject to limited regulation by the Utah Insurance Department.&nbsp; To
        file a complaint, contact the Utah Insurance Department.&nbsp; Coverage afforded under this Plan is not
        guaranteed by the Utah Property and Casualty Guarantee Association. If emergency service is required outside the
        designated hours, the consumer may seek service and be reimbursed, provided the service performed is covered by
        this Plan. The second sentence in the Cancellation provision is replaced with the following: “This Plan may be
        cancelled by us or the administrator prior to the expiration of the term for: (i) material misrepresentation or
        substantial breaches of contractual duties, conditions, or warranties, by notifying you in writing at least
        thirty (30) days prior to the effective date of cancellation; or (ii) for nonpayment of premium by notifying you
        in writing at least ten (10) days prior to the effective date of cancellation. Such cancellation notifications
        shall state the effective date and reason for cancellation.” The fourth sentence in the Insurance Securing this
        Plan provision is replaced with the following: “If within sixty (60) days after proof of loss has been filed we
        have not paid you for your claim, provided you with a refund owed, you are otherwise dissatisfied, or if we
        become insolvent or otherwise financially impaired, you may report a claim directly to the applicable insurance
        company at 55 Water St., 18th Floor, New York, NY 10041 for Liberty Insurance Underwriters, Inc. and at 175
        Berkeley Street, Boston, Massachusetts, 02116, for Liberty Mutual Insurance Company, or by calling toll free
        1-800-677-9163.” [If emergency service is required outside the designated hours, the consumer may seek service
        and be reimbursed, provided the service performed is covered by the Plan.]
      </Paragraph>
      <Paragraph>&nbsp;</Paragraph>
      <Paragraph>
        Washington Residents: If we fail to act on your claim, you may contact Liberty Insurance Underwriters Inc.
        directly at 1-800-677-9163. You are not required to wait sixty (60) days before filing a claim directly with
        Liberty Insurance Underwriters, Inc.&nbsp;{' '}
      </Paragraph>
      <Paragraph>&nbsp;</Paragraph>
      <Paragraph>
        Wisconsin Residents: THIS CONTRACT IS SUBJECT TO LIMITED REGULATION BY THE OFFICE OF THE COMMISSIONER OF
        INSURANCE.&nbsp; We may only cancel this contract before the end of the agreed contract term on the grounds of
        nonpayment, a material misrepresentation made by you to us, or a substantial breach of duties by you relating to
        the products or its use.&nbsp; The Arbitration Agreement provision of this contract is amended as follows:&nbsp;
        (1) TO RESOLVE DISPUTES, YOU MAY CHOOSE EITHER BINDING ARBITRATION, PURSUANT TO THE ARBITRATION AGREEMENT
        PROVISION OF THIS CONTRACT, OR SMALL CLAIMS COURT.&nbsp; BY AGREEING TO THIS CONTRACT, YOU AND WE WAIVE THE
        RIGHT TO HAVE DISPUTES RESOLVED THROUGH COURTS OF GENERAL JURISDICTION, THE RIGHT TO TRIAL BY JURY, AND TO
        PARTICIPATE IN CLASS ACTIONS, CLASS ARBITRATIONS OR OTHER REPRESENTATIVE PROCEEDINGS; and (2) the phrase “and is
        governed by the Federal Arbitration Act.” in the first sentence of paragraph (a) is deleted in its entirety.
      </Paragraph>
      <Paragraph>&nbsp;</Paragraph>
      <Paragraph>
        Wyoming Residents: The arbitration agreement provision in this Plan is replaced with the following: “If there
        are disputes between you and us that are not resolved by negotiations, you and we may in a separate written
        agreement voluntarily consent to arbitration. Any arbitration proceedings shall be conducted within the state of
        Wyoming.”&nbsp; For the purpose of this arbitration agreement, references to “we” and “us” include the Plan
        Obligor and administrator, as defined above, and their respective parents, subsidiaries, affiliates, service
        contract insurers, agents, employees, successors and assigns; and (2) Verizon Wireless and its wholly owned
        subsidiaries, affiliates, agents, employees, successors and assigns.&nbsp;&nbsp;{' '}
      </Paragraph>
      <Paragraph>&nbsp;</Paragraph>
      <Paragraph>Administered by: </Paragraph>
      <Paragraph>Asurion Warranty Services, Inc.</Paragraph>
      <Paragraph>Asurion Warranty Services of Florida, Inc.</Paragraph>
      <Paragraph>P.O. Box 1340 • Sterling, VA 20167 • 844-409-1998</Paragraph>
      <Paragraph>&copy; {new Date().getFullYear()} Asurion, LLC All rights reserved.</Paragraph>
    </>
  );
};

export default TermsAndConditions;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/termspage/VerizonTerms.tsx